<template>
  <div>
    <person-score-graph v-if="scoreData"
                        :score-data="scoreData"/>
  </div>
</template>

<script>
import ExperianService from "@/services/experian.service";
import PersonScoreGraph from "@/components/PersonScore/PersonScoreGraph.vue";

export default {
  name: "PersonScore",
  components: {PersonScoreGraph},
  props: ['rsaId'],
  data() {
    return {
      isLoading: false,
      scoreData: null,
    }
  },
  async created() {

    this.scoreData = await ExperianService.getPersonScore({
      rsaId: this.rsaId,
    })
  }
}
</script>

<style scoped>

</style>
